import { ResultApiResponse } from 'lib-shared-types-api';

import { api } from 'app/app.api';

import {
  CreateTrustpilotIntegrationApiArg,
  CreateTrustpilotIntegrationApiResponse,
  ReadTrustpilotIntegrationApiArg,
  ReadTrustpilotIntegrationApiResponse,
  ReadTrustpilotIntegrationsApiResponse,
  UpdateTrustpilotIntegrationApiArg,
} from './types/trustpilotApi.types';

export const trustpilotApi = api
  .enhanceEndpoints({ addTagTypes: ['Trustpilot'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      readTrustpilotIntegrations: builder.query<
        ReadTrustpilotIntegrationsApiResponse,
        void
      >({
        query: () => ({ version: 1, path: 'trustpilot/integrations' }),
        providesTags: ['Trustpilot'],
      }),
      readTrustpilotIntegration: builder.query<
        ReadTrustpilotIntegrationApiResponse,
        ReadTrustpilotIntegrationApiArg
      >({
        query: ({ id }) => ({
          version: 1,
          path: `trustpilot/integrations/${id}`,
        }),
        providesTags: ['Trustpilot'],
      }),
      updateTrustpilotIntegration: builder.mutation<
        { data: 'Success' },
        UpdateTrustpilotIntegrationApiArg
      >({
        query: ({ id, ...body }) => ({
          version: 1,
          path: `trustpilot/integrations/${id}`,
          method: 'PATCH',
          body,
        }),
        invalidatesTags: ['Trustpilot'],
      }),
      createTrustpilotIntegration: builder.mutation<
        CreateTrustpilotIntegrationApiResponse,
        CreateTrustpilotIntegrationApiArg
      >({
        query: (body) => ({
          version: 1,
          path: 'trustpilot/integrations',
          method: 'POST',
          body,
        }),
        invalidatesTags: ['Trustpilot'],
      }),
      deleteTrustpilotIntegration: builder.mutation<
        ResultApiResponse,
        ReadTrustpilotIntegrationApiArg
      >({
        query: ({ id }) => ({
          version: 1,
          path: `trustpilot/integrations/${id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['Trustpilot'],
      }),
    }),
  });
